module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('integration', {
    attrs: {
      "logoSrc": _vm.logoSrc,
      "label": _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateActive()
      }
    },
    model: {
      value: (_vm.internalActive),
      callback: function($$v) {
        _vm.internalActive = $$v
      },
      expression: "internalActive"
    }
  }, [_c('tag-list', {
    attrs: {
      "label": "Webinar key",
      "disabled": !_vm.internalActive,
      "value": _vm.internalKeys,
      "classes": ['no-margin']
    },
    on: {
      "input": function($event) {
        return _vm.updateKeys()
      }
    },
    model: {
      value: (_vm.internalKeys),
      callback: function($$v) {
        _vm.internalKeys = $$v
      },
      expression: "internalKeys"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82284058","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/integrations/GoToWebinar.vue
// module id = 1960
// module chunks = 0